import React from 'react';
import { MessageCircle } from 'lucide-react';

type Props = {
  title: string;
  description?: string;
  href?: string;
  buttonText?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
};

export default function LinkTreeCard({ title, description, href, buttonText, onClick, icon }: Props) {
  const isLink = !!href;

  return (
    <div className="w-full max-w-xl mx-auto">
      <div className="glass-card link-card rounded-2xl p-4 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4 border-maroon">
        <div className="flex items-start md:items-center gap-4">
          <div className="link-card-icon-maroon" aria-hidden>
            {icon ?? <MessageCircle className="w-5 h-5 text-white" />}
          </div>
        </div>

        <div className="flex-1">
          <h4 className="text-lg font-semibold text-white">{title}</h4>
          {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
        </div>

        <div className="w-full md:w-auto">
          {isLink ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={buttonText || title}
              className="w-full md:w-auto rounded-xl px-5 py-3 font-semibold transition-all duration-300 shadow-md gradient-button hover:shadow-glow hover:scale-[1.02] text-white focus:outline-none focus:ring-2 focus:ring-ring inline-block text-center btn-maroon"
            >
              {buttonText || 'Open'}
            </a>
          ) : (
            <button
              type="button"
              onClick={onClick}
              className="w-full md:w-auto rounded-xl px-5 py-3 font-semibold transition-all duration-300 shadow-md gradient-button hover:shadow-glow hover:scale-[1.02] text-white focus:outline-none focus:ring-2 focus:ring-ring btn-maroon"
            >
              {buttonText || 'Open'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
